import { useCallback, useContext, useEffect } from "react";

import { Button, Flex } from "@chakra-ui/react";

import {
  MultiAgencySelector,
  MultiLegalEntitySelector,
  MultiZoneSelector,
} from "@/components/2/data-selectors";
import { LegalEntityContext } from "@/components/2/legal-entity-context";

export type AgencyFiltersType = {
  entities?: string[];
  agencies?: string[];
  zones?: string[];
};

type AgencyFiltersProps = {
  setFilters: (filters: AgencyFiltersType) => void;
  filters: AgencyFiltersType;
};

export const AgencyFilters = ({ filters, setFilters }: AgencyFiltersProps) => {
  const legalEntityContext = useContext(LegalEntityContext);

  const resetFilters = useCallback(() => {
    setFilters({});
  }, [setFilters]);

  // Auto reset filters when legal entity context changes
  useEffect(() => {
    resetFilters();
    // `legalEntityContext` is the reset trigger, not a value read by the effect.
    // oxlint-disable-next-line react/exhaustive-effect-dependencies
  }, [legalEntityContext, resetFilters]);

  const enableResetButton = () => Object.values(filters).some(filter => filter?.length);

  return (
    <Flex gap={2}>
      <MultiLegalEntitySelector
        entities={filters.entities || []}
        onChange={newValues => setFilters({ ...filters, entities: newValues })}
      />

      <MultiAgencySelector
        selectedAgencies={filters.agencies || []}
        onChange={newValues => setFilters({ ...filters, agencies: newValues })}
      />

      <MultiZoneSelector
        selectedZones={filters.zones || []}
        onChange={newValues => setFilters({ ...filters, zones: newValues })}
      />

      {enableResetButton() && (
        <Button variant="plain" color={"blue"} onClick={resetFilters}>
          Effacer les filtres
        </Button>
      )}
    </Flex>
  );
};
